import React from "react";

function Footer() {
  return (
    <footer className="text-center py-4 bg-dark text-light">
      <p>© 2025 Dhyey Patel</p>
    </footer>
  );
}

export default Footer;
